import Image from "next/image";
import arrow from"../../assets/images/about/arrow.svg";
import styles from "./might-be-interest.module.css";
const Interest = () =>{
    const mightbe=[
        {content:"Faculties",href:"/faculty-list",img:arrow,alt:"arrow icon", title:"Link"},
        {content:"Visit the Centres",href:"/contact-us",img:arrow,alt:"arrow icon", title:"Link"}
    ]
    return (
        <>
{/*Might Be Intrested Section */}
                                            
<div className="container">
<div className="row">
  <h2 className={`${styles.sectiontitle} pt-2 pt-md-3`}>You might be interested in</h2>

    
   
    <div className="col-md-6  col-xl-4 col-12 mb-3 mb-md-3">
        <div className={`${styles.aboutbox1} p-lg-5 p-4 h-100`}>
            <div className="row">
                <div className="col-lg-7 col-md-8 col-6 align-self-center">
                <p className={`${styles.sectionsubtitle} mb-0`} style={{whitespace: "nowrap"}}>Study Materials</p>             
                </div>
                <div className="col-lg-5 col-md-4 col-6 text-end">
                    <a href="https://www.shankariasacademy.com/postalmaterial/upsc" target={"_blank"} rel="noreferrer"><Image src={arrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link"/></a>
                </div>
            </div>
        </div>
    </div>

    {mightbe.map((item, index) => (
    <div className="col-md-6  col-xl-4 col-12 mb-3 mb-md-3" key={index}>
        <div className={`${styles.aboutbox1} p-lg-5 p-4 h-100`}>
            <div className="row">
                <div className="col-lg-7 col-md-8 col-6 align-self-center">
                <p className={`${styles.sectionsubtitle} mb-0`} style={{whitespace: "nowrap"}}>{item.content}</p>             
                </div>
                <div className="col-lg-5 col-md-4 col-6 text-end">
                    <a href={item.href} rel="noreferrer"><Image src={arrow} className={`${styles.img} img-fluid`} alt={item.alt} title={item.title}/></a>
                </div>
            </div>
        </div>
    </div>
))}

</div>
</div>

</>
    )
}

export default Interest;
